import "./NoDataAvailable.css";

export function NoDataAvailable({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <div className="no-data-available-container">
      <p className="title">{title}</p>
      <p className="description">{description}</p>
    </div>
  );
}
